import { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { routes } from '../../Utils/routes';

export const RedirectHome: FC = () => <Redirect to={routes.requisitions.index} />;
